import React from "react";
import { TableCell, TableRow } from "../../../../../design/table";
import { Location } from "@visitproof/types";
import { Button } from "../../../../../design/button";
import { useDeleteAlert } from "../../../../../contexts/DeleteAlertProvider";
import { useLocation } from "../../../../../contexts/LocationContext";
import { useLocationDialog } from "../../../../../providers/LocationDialogProvider";

interface Props {
  location: Location;
}

const LocationLineItem: React.FC<Props> = ({ location }) => {
  const { openAlert } = useDeleteAlert();
  const { deleteLocationById } = useLocation();
  const {openEditDialog} = useLocationDialog();
  return (
    <TableRow key={location.id} title={`Location ${location.id}`}>
        <TableCell>
          <div className="flex items-center gap-2">
            <div className="flex flex-col">
              {location.name}
              {location.name !== location.formattedAddress &&
                location.formattedAddress && (
                  <div className="text-sm text-gray-500">
                    {location.formattedAddress}
                  </div>
                )}
            </div>
          </div>
        </TableCell>
        <TableCell className="space-x-2 text-right">
            <Button onClick={() => openEditDialog({ location })}>
              Edit
            </Button>
            <Button
              onClick={() => {
                openAlert(location, {
                  displayName: "location",
                  onDelete: deleteLocationById,
                  getId: (entity) => entity.id,
                });
              }}
              color="red"
            >
              Delete
            </Button>
        </TableCell>
      </TableRow>
  );
};

export default LocationLineItem;
